<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
    <dx-lookup [gsResource]="warehouses" formControlName="warehouseId" displayExpr="name" valueExpr="id" formField
        required [label]="'entity.product.warehouse' | translate | ucfirst" [createComponent]="createWarehouseComponent"></dx-lookup>
        <dx-lookup [gsResource]="seasonalities" formControlName="seasonalityId" displayExpr="name" valueExpr="id" formField
        required [label]="'entity.product.seasonalityId' | translate | ucfirst" [createComponent]="addSeasonality"></dx-lookup>
    <dx-number-box formControlName="minStock" formField required
        [label]="'entity.product.minStock' | translate | ucfirst">
    </dx-number-box>
    <dx-number-box formControlName="maxStock" formField required
    [label]="'entity.product.maxStock' | translate | ucfirst">
    </dx-number-box>
    <dx-number-box formControlName="securityStock" formField required
    [label]="'entity.product.securityStock' | translate | ucfirst">
    </dx-number-box>
    <dx-number-box formControlName="optimalOrderAmount" formField required
    [label]="'entity.product.optimalOrderAmount' | translate | ucfirst">
    </dx-number-box>
</form>